import { useCallback } from "react";
import { yupResolver } from "@hookform/resolvers/yup";

import Grid from "@mui/material/Grid";

import { useFormWithNotification } from "@covertree/hooks";
import { FormTextField } from "@covertree/ui";
import FormPhoneField from "@covertree/ui/forms/FormPhoneField";
import { FormSelectField } from "@covertree/ui/forms/FormSelectField";

import { useAppDispatch, useAppSelector } from "@redux/hooks";
import { StepPath } from "@routing/paths";
import { selectClaimReporter, submitClaimReporterForm } from "@redux/slices";

import { RelationshipToInsured } from "@api/operations.generated";

import { ClaimsForm } from "../ClaimsForm";
import { ClaimReporterForm, validation } from "./form";

const relationshipToInsuredOptions = [
  {
    label: "Policyholder",
    value: RelationshipToInsured.Policyholder,
  },
  {
    label: "Family Member",
    value: RelationshipToInsured.FamilyMember,
  },
  { label: "Spouse", value: RelationshipToInsured.Spouse },
  { label: "Child", value: RelationshipToInsured.Child },
  { label: "Second Owner", value: RelationshipToInsured.SecondOwner },
  { label: "Other", value: RelationshipToInsured.Other },
];

export function ClaimReporter() {
  const dispatch = useAppDispatch();

  const defaultValues = useAppSelector(selectClaimReporter);

  const form = useFormWithNotification({
    mode: "all",
    reValidateMode: "onSubmit",
    defaultValues: { ...defaultValues },
    resolver: yupResolver(validation),
  });
  const { control } = form;

  const handleSubmit = useCallback((formValue: ClaimReporterForm) => {
    dispatch(submitClaimReporterForm(formValue));
  }, []);

  return (
    <ClaimsForm
      form={form}
      onSubmit={handleSubmit}
      navigateToStep={StepPath.SUMMARY}>
      <Grid item container xs={12} spacing={3}>
        <Grid item xs={12} md={6}>
          <FormTextField
            id="first-name"
            dataTestId="first-name"
            name="firstName"
            label="First name"
            control={control}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <FormTextField
            id="last-name"
            dataTestId="last-name"
            name="lastName"
            label="Last name"
            control={control}
          />
        </Grid>
      </Grid>
      <Grid item xs={12}>
        <FormSelectField
          id="relationship-to-insured"
          dataTestId="relationship-to-insured"
          name="relationshipToInsured"
          options={relationshipToInsuredOptions}
          label="Relationship to insured"
          control={control}
        />
      </Grid>
      <Grid item xs={12}>
        <FormPhoneField
          id="phone-number"
          dataTestId="phone-number"
          name="phoneNumber"
          label="Phone number"
          control={control}
        />
      </Grid>
    </ClaimsForm>
  );
}
